import PaymentForm from './PaymentForm'

const SUBSCRIPTION_BRICK_IDS = [
  'planChange',
  'planChangeConfirm',
  'addonContract',
  'addonContractConfirm',
  'planResume'
]

const PlanChangePaymentForm = (props) => {
  const brickId = props.brickId ?? 'planChange'
  const flowType =
    props.flowType ??
    (brickId === 'addonContract' || brickId === 'addonContractConfirm'
      ? 'addon_subscription'
      : 'plan_subscription')

  return (
    <PaymentForm
      {...props}
      brickId={brickId}
      isSubscription={Boolean(SUBSCRIPTION_BRICK_IDS.includes(brickId))}
      flowType={flowType}
      saveCard={false}
      managedByParent
      successMessage={props.successMessage ?? 'Plan actualizado correctamente.'}
    />
  )
}

export default PlanChangePaymentForm
